/**
 * @generated SignedSource<<65086bf7db6f0708a3b93d44d31cbf56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PERIODICITY = "DAILY" | "WEEKLY" | "MONTHLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type UpdateProjectInput = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  status?: string | null;
  stageId?: string | null;
  active?: boolean | null;
  projectColor?: string | null;
  customProjectId?: string | null;
  clientId?: string | null;
  clientContactId?: string | null;
  salespersonId?: string | null;
  projectOwner?: string | null;
  projectManagers?: ReadonlyArray<string | null> | null;
  statusColumns?: ReadonlyArray<StatusColumnInput | null> | null;
  estimationUnit?: string | null;
  sprintTimeBox?: boolean | null;
  sprintLengthInDays?: number | null;
  projectStartYear?: number | null;
  projectStartMonth?: number | null;
  projectStartDay?: number | null;
  projectEndYear?: number | null;
  projectEndMonth?: number | null;
  projectEndDay?: number | null;
  taskLevels?: number | null;
  useTaskHierarchy?: boolean | null;
  rateCardId?: string | null;
  labels?: ReadonlyArray<string | null> | null;
  minutesPerEstimationPoint?: number | null;
  budget?: number | null;
  budgetType?: BUDGET_TYPE | null;
  defaultPeriodPriceAmount?: number | null;
  defaultPeriodHoursAmount?: number | null;
  defaultPeriodBudgetType?: PERIOD_BUDGET_TYPE | null;
  defaultPeriodLength?: number | null;
  defaultPeriodPeriodicity?: PERIODICITY | null;
  defaultPeriodSettingIgnoreForBilling?: boolean | null;
  defaultPeriodSettingSubtractValue?: boolean | null;
  defaultPeriodSettingRollValue?: boolean | null;
  defaultPeriodSettingAddExpenses?: boolean | null;
  revenueMarginLow?: number | null;
  revenueMarginHigh?: number | null;
  economicProjectId?: string | null;
  harvestProjectId?: string | null;
  newHarvestProjectId?: string | null;
  jiraProjectId?: string | null;
  jiraCutoffDate?: string | null;
  excludedHarvestTasks?: ReadonlyArray<string | null> | null;
  newExcludedHarvestTasks?: ReadonlyArray<number | null> | null;
  timelogProjectId?: string | null;
  newTimelogProjectId?: string | null;
  initTaskImport?: boolean | null;
  slackChannelId?: string | null;
  approveNoPhaseTasks?: boolean | null;
  billable?: boolean | null;
  projectGroupId?: string | null;
  previousProjectGroupId?: string | null;
  salesforceOpportunity?: string | null;
  unit4Project?: string | null;
  githubRepositories?: ReadonlyArray<string | null> | null;
  githubRepositoryIds?: ReadonlyArray<number | null> | null;
  remainingAutoCalculated?: boolean | null;
  useManualAllocations?: boolean | null;
  taskCostCalculationType?: string | null;
  unassignedTaskHourlyCost?: number | null;
  useTaskOwner?: boolean | null;
  useTaskFollowers?: boolean | null;
  currencyExchangeRate?: number | null;
  fixedPriceRateCardSetting?: number | null;
  usePublicCreateTaskPage?: boolean | null;
  usePublicCreateTaskPassword?: boolean | null;
  publicCreateTaskPassword?: string | null;
  publicCreateTaskPageStatusColumnId?: string | null;
  unsynchedJiraProject?: boolean | null;
  useBaseline?: boolean | null;
  synchBaselineAndScopingDates?: boolean | null;
  useFixedPriceForBaselineRevenue?: boolean | null;
  useDeliverables?: boolean | null;
  synchDatesSetting?: string | null;
  baselineWinChance?: number | null;
  baselineTarget?: number | null;
  priorityLevelId?: string | null;
  manualProgressOnProjectEnabled?: boolean | null;
  manualProgressOnPhasesEnabled?: boolean | null;
  manualProgressOnTasksEnabled?: boolean | null;
  flatRate?: number | null;
  flatCost?: number | null;
  financialSourceSettings?: FinancialSourceSettingsInput | null;
  sageProjectId?: string | null;
  sageIntacctLocationEntityId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StatusColumnInput = {
  id?: string | null;
  name?: string | null;
  order?: number | null;
  category?: string | null;
  projectId?: string | null;
  projectGroupStatusColumnId?: number | null;
  autoShowOnTimePage?: boolean | null;
  encourageTimeRegistration?: boolean | null;
};
export type FinancialSourceSettingsInput = {
  plannedHours?: string | null;
  plannedRevenue?: string | null;
  plannedCost?: string | null;
  forecastHours?: string | null;
  forecastRevenue?: string | null;
  forecastCost?: string | null;
  actualHours?: string | null;
  actualRevenue?: string | null;
  actualCost?: string | null;
};
export type updateProjectGroupProjectsMutation$variables = {
  input: UpdateProjectInput;
};
export type updateProjectGroupProjectsMutation$data = {
  readonly updateProject: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly project: {
      readonly " $fragmentSpreads": FragmentRefs<"ProjectSettingsPage_project">;
    } | null;
    readonly projectGroup: {
      readonly projects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly previousProjectGroup: {
      readonly projects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly viewer: {
      readonly projectGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null> | null;
      } | null;
      readonly headerProjectGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type updateProjectGroupProjectsMutation = {
  variables: updateProjectGroupProjectsMutation$variables;
  response: updateProjectGroupProjectsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  (v7/*: any*/)
],
v9 = [
  {
    "alias": "projects",
    "args": null,
    "concreteType": "ProjectTypeConnection",
    "kind": "LinkedField",
    "name": "__ProjectGroup_projects_connection",
    "plural": false,
    "selections": (v8/*: any*/),
    "storageKey": null
  }
],
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectGroupTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectGroupType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  (v7/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  (v3/*: any*/),
  (v11/*: any*/)
],
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v24 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v25 = [
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v27 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "progress",
    "storageKey": null
  },
  (v26/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Person",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": [
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v28 = [
  (v3/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v30 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v32 = [
  (v24/*: any*/),
  {
    "kind": "Literal",
    "name": "includeInactive",
    "value": true
  }
],
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v35 = [
  {
    "alias": null,
    "args": (v30/*: any*/),
    "concreteType": "ProjectTypeConnection",
    "kind": "LinkedField",
    "name": "projects",
    "plural": false,
    "selections": (v8/*: any*/),
    "storageKey": "projects(first:100000)"
  },
  {
    "alias": null,
    "args": (v30/*: any*/),
    "filters": ([]/*: any*/),
    "handle": "connection",
    "key": "ProjectGroup_projects",
    "kind": "LinkedHandle",
    "name": "projects"
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectGroupProjectsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectSettingsPage_project"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "previousProjectGroup",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": "projectGroups",
                "args": null,
                "concreteType": "ProjectGroupTypeConnection",
                "kind": "LinkedField",
                "name": "__Viewer_projectGroups_connection",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": "headerProjectGroups",
                "args": null,
                "concreteType": "ProjectGroupTypeConnection",
                "kind": "LinkedField",
                "name": "__Viewer_headerProjectGroups_connection",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectGroupProjectsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PriorityLevel",
                "kind": "LinkedField",
                "name": "priorityLevel",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnProjectEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnPhasesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnTasksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "TimeRegTypeConnection",
                "kind": "LinkedField",
                "name": "timeRegistrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "timeRegistrations(first:1)"
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Task_timeRegistrations",
                "kind": "LinkedHandle",
                "name": "timeRegistrations"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectId",
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInProjectGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sprintTimeBox",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialSourceSettings",
                "kind": "LinkedField",
                "name": "financialSourceSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenue",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualHours",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectPortalConfig",
                "kind": "LinkedField",
                "name": "portalConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showInClientPortal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "portalPhaseStatusVisible",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodPeriodicity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodLength",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodHoursAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodPriceAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodSettingSubtractValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodSettingRollValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "githubRepositoryIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useManualAllocations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskCostCalculationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unassignedTaskHourlyCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linkToPublicCreateTaskPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usePublicCreateTaskPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicCreateTaskPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusColumnV2",
                "kind": "LinkedField",
                "name": "publicCreateTaskPageStatusColumn",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueMarginLow",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueMarginHigh",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasLockedPeriod",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasLockedTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userCanDeleteProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userCantDeleteProjectReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineWinChance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SageProjectType",
                "kind": "LinkedField",
                "name": "sageProject",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sageProjectId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sageIntacctLocationEntityId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectStatus",
                "kind": "LinkedField",
                "name": "currentProjectStatus",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "person",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "ProjectStatusTypeConnection",
                "kind": "LinkedField",
                "name": "projectStatuses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectStatusTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectStatus",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v18/*: any*/),
                          (v17/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hour",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minute",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "second",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v22/*: any*/),
                              (v21/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          (v14/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "projectStatuses(first:10000)"
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Project_projectStatuses",
                "kind": "LinkedHandle",
                "name": "projectStatuses"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectProgress",
                "kind": "LinkedField",
                "name": "progressDetails",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectProgress",
                "kind": "LinkedField",
                "name": "progressHistory",
                "plural": true,
                "selections": (v27/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isProgramRevenueLocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "programBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "programRemainingBudget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "program",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prefix",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalAllocation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "budgetValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "revenueSetting",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProgramMemberTypeConnection",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectServiceProgramMemberTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectServiceProgramMemberType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "role",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HarvestProjectType",
                "kind": "LinkedField",
                "name": "harvestProject",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraSyncRemaining",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectType",
                "kind": "LinkedField",
                "name": "jiraCloudProject",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "style",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "syncRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cutoffDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSyncDone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "syncSprints",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimateInTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimateInPointsCustomFieldName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mapJiraSubTasksToToDo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mapJiraVersionsToPhases",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEpicIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraErrorTypeConnection",
                "kind": "LinkedField",
                "name": "jiraErrors",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraErrorTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraErrorType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Task",
                            "kind": "LinkedField",
                            "name": "task",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeRegId",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "concreteType": "TaskTypeConnection",
                "kind": "LinkedField",
                "name": "tasks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentTaskId",
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "statusColumnV2",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v31/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sageIntacctId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "tasks(first:100000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskHierarchy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profile",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerProjectType",
                "kind": "LinkedField",
                "name": "jiraServerProject",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isJiraProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slackChannelId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackChannelType",
                "kind": "LinkedField",
                "name": "slackChannel",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salesforceOpportunity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Unit4ProjectType",
                "kind": "LinkedField",
                "name": "unit4Project",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hubspotDeal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pipedriveDeal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsAccount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsArea",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsSyncBugs",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsTwoWaySync",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsUseEpics",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsUseNewSubtasks",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabProjectName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerProjectName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitHubSyncTarget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                  }
                ],
                "concreteType": "StatusColumnV2TypeConnection",
                "kind": "LinkedField",
                "name": "statusColumnsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2TypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v31/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "statusColumnsV2(first:1000000)"
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "ProjectLabelTypeConnection",
                "kind": "LinkedField",
                "name": "projectLabels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectLabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "label",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v11/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectLabels(first:10000)"
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimationUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sprintLengthInDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskLevels",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useDeliverables",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minutesPerEstimationPoint",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remainingAutoCalculated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskFollowers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "RetainerPeriodTypeConnection",
                "kind": "LinkedField",
                "name": "retainerPeriods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetainerPeriodTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetainerPeriodType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "retainerPeriods(first:1)"
              },
              {
                "alias": null,
                "args": (v32/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isContactPerson",
                            "storageKey": null
                          },
                          (v33/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v25/*: any*/),
                                "concreteType": "ProfileTypeConnection",
                                "kind": "LinkedField",
                                "name": "profiles",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProfileTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Profile",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v12/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "profiles(first:10000)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "permissions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "active",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isViewer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "harvestUser",
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1000
                                  }
                                ],
                                "concreteType": "PersonLabelTypeConnection",
                                "kind": "LinkedField",
                                "name": "personLabels",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PersonLabelTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PersonLabel",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "label",
                                            "plural": false,
                                            "selections": (v12/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "personLabels(first:1000)"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "relationType",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "projectPersons(first:10000,includeInactive:true)"
              },
              {
                "alias": null,
                "args": (v32/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_projectPersons",
                "kind": "LinkedHandle",
                "name": "projectPersons"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "disabledRoles",
                    "plural": true,
                    "selections": (v28/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": (v25/*: any*/),
                    "concreteType": "ClientBillToTypeConnection",
                    "kind": "LinkedField",
                    "name": "clientBillTos",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientBillToTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientBillTo",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillTo",
                                "kind": "LinkedField",
                                "name": "billTo",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillFrom",
                                "kind": "LinkedField",
                                "name": "billFrom",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": "clientBillTos(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": (v25/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "BillFrom_clientBillTos",
                    "kind": "LinkedHandle",
                    "name": "clientBillTos"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientContact",
                "kind": "LinkedField",
                "name": "clientContact",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "ProjectBillToTypeConnection",
                "kind": "LinkedField",
                "name": "projectBillTos",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectBillToTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectBillTo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "clientBillToId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectId",
                            "storageKey": null
                          },
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoiced",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BillTo",
                            "kind": "LinkedField",
                            "name": "billTo",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BillFrom",
                            "kind": "LinkedField",
                            "name": "billFrom",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "integration",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "projectBillTos(first:10000)"
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_projectBillTos",
                "kind": "LinkedHandle",
                "name": "projectBillTos"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": (v35/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "previousProjectGroup",
            "plural": false,
            "selections": (v35/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v30/*: any*/),
                "concreteType": "ProjectGroupTypeConnection",
                "kind": "LinkedField",
                "name": "projectGroups",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": "projectGroups(first:100000)"
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Viewer_projectGroups",
                "kind": "LinkedHandle",
                "name": "projectGroups"
              },
              {
                "alias": "headerProjectGroups",
                "args": (v30/*: any*/),
                "concreteType": "ProjectGroupTypeConnection",
                "kind": "LinkedField",
                "name": "projectGroups",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": "projectGroups(first:100000)"
              },
              {
                "alias": "headerProjectGroups",
                "args": (v30/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Viewer_headerProjectGroups",
                "kind": "LinkedHandle",
                "name": "projectGroups"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7044bc1f815c750442b9635dc23c8e2",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateProject",
            "projectGroup",
            "projects"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateProject",
            "previousProjectGroup",
            "projects"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateProject",
            "viewer",
            "projectGroups"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateProject",
            "viewer",
            "headerProjectGroups"
          ]
        }
      ]
    },
    "name": "updateProjectGroupProjectsMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectGroupProjectsMutation(\n  $input: UpdateProjectInput!\n) {\n  updateProject(input: $input) {\n    errors\n    project {\n      ...ProjectSettingsPage_project\n      id\n    }\n    projectGroup {\n      projects(first: 100000) {\n        edges {\n          node {\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n    previousProjectGroup {\n      projects(first: 100000) {\n        edges {\n          node {\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n    viewer {\n      projectGroups(first: 100000) {\n        edges {\n          node {\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      headerProjectGroups: projectGroups(first: 100000) {\n        edges {\n          node {\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment JiraIntegrationSection_project on ProjectType {\n  id\n  name\n  jiraCloudProjectSettings {\n    syncRemaining\n    cutoffDate\n    isSyncDone\n    syncSprints\n    estimateInTime\n    estimateInPointsCustomFieldName\n    mapJiraSubTasksToToDo\n    mapJiraVersionsToPhases\n    id\n  }\n  jiraCloudEpicIds\n  jiraCloudProject {\n    id\n    name\n    style\n  }\n  jiraErrors {\n    edges {\n      node {\n        createdAt\n        errorCode\n        task {\n          id\n          companyTaskId\n        }\n        timeRegId\n        id\n      }\n    }\n  }\n  tasks(first: 100000) {\n    edges {\n      node {\n        id\n        parentTaskId\n      }\n    }\n  }\n  useTaskHierarchy\n  stage {\n    __typename\n    id\n    name\n    profile\n  }\n}\n\nfragment ProjectHeader_project on ProjectType {\n  id\n  companyProjectId\n  ...ProjectIndicatorJS_project\n  name\n  projectColor\n  isInProjectGroup\n  projectGroupCompanyId\n  projectGroupName\n  projectGroupColor\n  useBaseline\n  budgetType\n  sprintTimeBox\n}\n\nfragment ProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment ProjectManualProgressConfiguration_project on ProjectType {\n  id\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n  timeRegistrations(first: 1) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProjectPriorityDropdown_project on ProjectType {\n  id\n  priorityLevel {\n    id\n    name\n  }\n}\n\nfragment ProjectSettingsPage_project on ProjectType {\n  id\n  ...ProjectPriorityDropdown_project\n  ...ProjectManualProgressConfiguration_project\n  ...ProjectHeader_project\n  ...SecondaryNavigation_project\n  ...ValueCalculations_project\n  companyProjectId\n  portalConfig {\n    showInClientPortal\n    portalPhaseStatusVisible\n  }\n  customProjectId\n  isInProjectGroup\n  projectGroupId\n  name\n  budgetType\n  budget\n  useBaseline\n  defaultPeriodPeriodicity\n  defaultPeriodLength\n  defaultPeriodBudgetType\n  defaultPeriodHoursAmount\n  defaultPeriodPriceAmount\n  defaultPeriodSettingSubtractValue\n  defaultPeriodSettingRollValue\n  githubRepositoryIds\n  useManualAllocations\n  taskCostCalculationType\n  unassignedTaskHourlyCost\n  linkToPublicCreateTaskPage\n  usePublicCreateTaskPassword\n  publicCreateTaskPassword\n  publicCreateTaskPageStatusColumn {\n    id\n    name\n  }\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n  revenueMarginLow\n  revenueMarginHigh\n  hasInvoices\n  hasLockedPeriod\n  hasLockedTime\n  userCanDeleteProject\n  userCantDeleteProjectReason\n  baselineWinChance\n  teamsId\n  sageProject {\n    id\n    sageProjectId\n    sageIntacctLocationEntityId\n  }\n  currentProjectStatus {\n    id\n    color\n    description\n    day\n    month\n    year\n    person {\n      id\n      firstName\n      lastName\n      profilePictureId\n    }\n    ...ProjectStatus_projectStatus\n  }\n  projectStatuses(first: 10000) {\n    edges {\n      node {\n        id\n        year\n        month\n        day\n        hour\n        minute\n        second\n        ...ProjectStatus_projectStatus\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  progressDetails {\n    id\n    progress\n    createdAt\n    createdBy {\n      firstName\n      lastName\n      profilePictureId\n      id\n    }\n  }\n  progressHistory {\n    id\n    progress\n    createdAt\n    createdBy {\n      firstName\n      lastName\n      profilePictureId\n      id\n    }\n  }\n  isProgramRevenueLocked\n  programBudgetType\n  programRemainingBudget\n  program {\n    name\n    prefix\n    totalAllocation\n    budgetValue\n    revenueSetting\n    members {\n      edges {\n        node {\n          role\n          person {\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  harvestProject {\n    id\n  }\n  harvestProjectId\n  jiraSyncRemaining\n  jiraCloudProject {\n    id\n    name\n  }\n  ...JiraIntegrationSection_project\n  jiraServerProject {\n    id\n    name\n  }\n  isJiraProject\n  slackChannelId\n  slackChannel {\n    id\n  }\n  salesforceOpportunity\n  unit4Project {\n    id\n    name\n  }\n  hubspotDeal\n  pipedriveDeal\n  vstsProject\n  vstsAccount\n  vstsArea\n  vstsSyncBugs\n  vstsTwoWaySync\n  vstsUseEpics\n  vstsUseNewSubtasks\n  gitlabProjectId\n  gitlabProjectName\n  gitlabServerProjectId\n  gitlabServerProjectName\n  gitHubSyncTarget\n  stage {\n    __typename\n    id\n    name\n    profile\n  }\n  projectColor\n  statusColumnsV2(first: 1000000) {\n    edges {\n      node {\n        id\n        category\n        name\n      }\n    }\n  }\n  projectLabels(first: 10000) {\n    edges {\n      node {\n        id\n        label {\n          id\n          name\n          color\n        }\n      }\n    }\n  }\n  description\n  estimationUnit\n  sprintTimeBox\n  sprintLengthInDays\n  projectStartYear\n  projectStartMonth\n  projectStartDay\n  projectEndYear\n  projectEndMonth\n  projectEndDay\n  taskLevels\n  useTaskHierarchy\n  useDeliverables\n  minutesPerEstimationPoint\n  billable\n  remainingAutoCalculated\n  useTaskOwner\n  useTaskFollowers\n  retainerPeriods(first: 1) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  projectPersons(first: 10000, includeInactive: true) {\n    edges {\n      node {\n        id\n        isContactPerson\n        role {\n          id\n          name\n        }\n        person {\n          id\n          firstName\n          lastName\n          fullName\n          initials\n          profiles(first: 10000) {\n            edges {\n              node {\n                id\n                name\n              }\n            }\n          }\n          permissions\n          email\n          profilePictureId\n          profilePictureDefaultId\n          active\n          isViewer\n          harvestUser\n          role {\n            id\n            name\n          }\n          personLabels(first: 1000) {\n            edges {\n              node {\n                id\n                label {\n                  id\n                  name\n                }\n              }\n            }\n          }\n        }\n        relationType\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  rateCard {\n    id\n    currency\n    disabledRoles {\n      id\n    }\n  }\n  client {\n    id\n    name\n    clientBillTos(first: 10000) {\n      edges {\n        node {\n          id\n          clientId\n          billTo {\n            id\n          }\n          billFrom {\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  clientContact {\n    id\n    firstName\n    lastName\n  }\n  tasks(first: 100000) {\n    edges {\n      node {\n        id\n        name\n        companyTaskId\n        statusColumnV2 {\n          name\n          category\n          id\n        }\n        parentTaskId\n        sageIntacctId\n      }\n    }\n  }\n  projectBillTos(first: 10000) {\n    edges {\n      node {\n        id\n        clientBillToId\n        projectId\n        clientId\n        invoiced\n        billTo {\n          id\n          name\n        }\n        billFrom {\n          id\n          name\n          integration\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProjectStatus_projectStatus on ProjectStatus {\n  id\n  person {\n    id\n    fullName\n    profilePictureId\n    profilePictureDefaultId\n  }\n  description\n  color\n  day\n  month\n  year\n}\n\nfragment SecondaryNavigation_project on ProjectType {\n  companyProjectId\n  customProjectId\n  sprintTimeBox\n  budgetType\n  projectGroupId\n  useBaseline\n  hasInvoices\n  financialSourceSettings {\n    plannedCost\n    plannedRevenue\n    actualCost\n    actualRevenue\n    forecastCost\n    forecastRevenue\n    id\n  }\n}\n\nfragment ValueCalculations_project on ProjectType {\n  id\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "04de2e186bae96b64e69a44d8a15093e";

export default node;
